import React from "react";

const MediaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_14564_38624)">
        <path
          d="M19.11 21.1844C17.14 20.2692 15.31 19.0557 13.68 17.5852L13.42 17.3795C11.37 15.693 9.57999 14.243 7.73999 14.3767C5.95999 14.675 4.31 15.5285 3 16.8139"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          stroke="currentColor"
        />
        <path
          d="M13.6699 17.5845C14.6499 16.4533 15.9699 15.682 17.4199 15.3941C18.5599 15.3118 19.68 16.1756 20.95 17.2143"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          stroke="currentColor"
        />
        <path
          d="M14.9707 10.8488C16.0807 10.8488 16.9707 9.92326 16.9707 8.79206C16.9707 7.66087 16.0707 6.73535 14.9707 6.73535C13.8707 6.73535 12.9707 7.66087 12.9707 8.79206C12.9707 9.92326 13.8707 10.8488 14.9707 10.8488Z"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          stroke="currentColor"
        />
        <path
          d="M17.77 3.08496H6.22998C4.44998 3.08496 3 4.57609 3 6.40656V18.2738C3 20.1042 4.44998 21.5954 6.22998 21.5954H17.77C19.55 21.5954 21 20.1042 21 18.2738V6.40656C21 4.57609 19.55 3.08496 17.77 3.08496Z"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          stroke="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_14564_38624">
          <rect width="24" height="24.6806" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MediaIcon;
